import React, { Component, Fragment } from 'react';
import { signOut, sendPasswordResetEmail, getAuth } from "firebase/auth";
import { httpsCallable } from 'firebase/functions';
import { Link } from 'react-router-dom';
import { Button, Navbar, Nav, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, } from 'reactstrap';
import Select from 'react-select';
import qs from 'qs';
import { format as formatDate, startOfMonth, endOfMonth, differenceInDays, } from 'date-fns';
import { isEmpty, } from 'lodash';
import { toast } from 'react-toastify';
import classnames from 'classnames';
import { useToggle, } from 'react-use';
import { useLocation, } from 'react-router';
import copy from 'copy-to-clipboard';
import logoHorizontal from '../assets/logo-horizontal.png';

import firebase, { functions, auth, } from '../firebase';
import { updateDoc, collection, query, where, limit } from 'firebase/firestore';
import useUser from './hooks/useUser';
import useFirebaseUser from './hooks/useFirebaseUser';
import useCollectionSubscription from './hooks/useCollectionSubscription';
import EditButton from './EditButton';
import env from '../env';

const { entries } = Object;

export default function HeaderNav (props) {
  const { links, admin = false, tenant, } = props;
  const location = useLocation();
  const { user } = useUser();
  const { emailVerified } = useFirebaseUser();
  const [isDemoLoading, toggleDemoLoading] = useToggle(false);
  const [isSendingVerification, toggleSendingVerification] = useToggle(false);
  const isDemo = tenant?.hasDemo && !['active', 'trialing'].includes(tenant?.subscriptionStatus);
  // 過去データ取り込み(backfill)が進行中かどうか。未完了ジョブが1件でもあれば「取り込み中」。
  // 進捗数は見ず、やっているか否かだけ分かればよいので limit(1) で軽く判定する。
  // done/failed/skip 以外(=処理中・投入待ちの中間状態)を「進行中」とみなす。
  // pending だけだと processing/requesting 等の合間にバーが消えてチラつくため in で列挙する。
  const inProgressSalesBackfill = useCollectionSubscription(
    tenant ? query(collection(tenant.ref, 'backfillJobs'), where('salesStatus', 'in', ['pending', 'processing']), limit(1)) : null,
  );
  const inProgressAdBackfill = useCollectionSubscription(
    tenant ? query(collection(tenant.ref, 'backfillJobs'), where('adStatus', 'in', ['pending', 'requesting', 'fetchPending', 'fetching']), limit(1)) : null,
  );
  const isBackfilling = inProgressSalesBackfill.length > 0 || inProgressAdBackfill.length > 0;
  const createdAt = user?.createdAt?.toDate?.() || (user?.createdAt && new Date(user.createdAt));
  const daysLeft = createdAt ? Math.max(0, 7 - differenceInDays(new Date(), createdAt)) : null;
  const showsEmailBanner = !emailVerified && daysLeft != null && daysLeft > 0;
  const onClickSendVerification = async () => {
    toggleSendingVerification();
    try {
      const resendEmailVerification = httpsCallable(functions, 'resendEmailVerification');
      await resendEmailVerification();
      toast.success('メールアドレス確認メールを送信しました');
    } catch (e) {
      toast.error('送信失敗しました');
      console.error(e);
    }
    toggleSendingVerification();
  };
  const onClickLogOut = async () => {
    if(!window.confirm('ログアウトしますか？')) return;
    await signOut(auth);
    window.location.href = '/';
  }
  const onClickPasswordReset = async () => {
    if(!window.confirm('パスワード変更のためのメールをお送りします。よろしいですか？')) return;
    await sendPasswordResetEmail(auth, user.email)
    toast.success('パスワードリセットのメールをお送りしました。');
  };

  return (
    <header className="header-nav fixed-top">
      {showsEmailBanner && (
        <div className="bg-warning bg-opacity-10 border-bottom border-warning py-2 px-3 d-flex align-items-center justify-content-center gap-3">
          <span className="small">メールアドレスが未確認です。あと{daysLeft}日以内に確認を完了してください。</span>
          <Button color="warning" size="sm" onClick={onClickSendVerification} disabled={isSendingVerification}>
            確認メールを再送信
          </Button>
        </div>
      )}
      {isDemo && (
        <div className="bg-info bg-opacity-10 border-bottom border-info py-2 px-3 d-flex align-items-center justify-content-center gap-3">
          <span className="small">デモデータを表示中です。実際のデータで利用するにはトライアルを開始してください。</span>
          <Button color="primary" size="sm" onClick={async () => {
            toggleDemoLoading(true);
            try {
              await updateDoc(tenant.ref, { wantsActivation: true });
            } catch (e) {
              console.error(e);
              toast.error('エラーが発生しました。');
              toggleDemoLoading(false);
            }
          }} disabled={isDemoLoading}>
            {isDemoLoading ? '処理中...' : '実利用に進む'}
          </Button>
        </div>
      )}
      {isBackfilling && (
        <div className="bg-info bg-opacity-10 border-bottom border-info py-2 px-3 d-flex align-items-center justify-content-center gap-3">
          <span className="small">
            <span className="spinner-border spinner-border-sm me-2" role="status" />
            過去データを取り込み中です。反映まで少しお待ちください。
          </span>
        </div>
      )}
      <Navbar className={`px-3 justify-content-between border-0 ${admin ? 'bg-dark' : 'bg-transparent'}`}> <div className="d-flex gap-3 align-items-center">
          <Link to={admin ? '/admin' : '/'} className={`navbar-brand d-flex align-items-center ${admin ? 'text-white' : ''}`}>
            <img src={logoHorizontal} alt="Totono" style={{ height: 32 }} />
            {admin && <span className="ms-2">Admin</span>}
            {import.meta.env.VITE_ENV !== 'production' && <span className="ms-1 badge bg-warning">{(import.meta.env.VITE_ENV || 'development').toString()}</span>}
          </Link>
        </div>
        <Nav navbar className="flex-fill flex-row justify-content-end gap-2 align-items-center">
          {
            user != null && (
              <UncontrolledDropdown tag="div">
                <DropdownToggle nav caret className={admin ? 'text-white' : ''}>
                  {user.displayName || '(ユーザー未設定)'}
                </DropdownToggle>
                <DropdownMenu right>
                  {
                    user.admin && (
                      <DropdownItem tag={Link} to="/admin">
                        管理画面
                      </DropdownItem>
                    )
                  }
                  {
                    /*
                    <DropdownItem tag="a" href={env('SP_API_AUTH_CONSENT_URI')} className="d-flex flex-column align-items-stretch">
                      <div>SP API認証</div>
                    </DropdownItem>
                    */
                  }
                  <DropdownItem tag={Link} to="/mypage/profile">
                    プロフィール
                  </DropdownItem>
                  <DropdownItem onClick={onClickPasswordReset}>
                    パスワード変更
                  </DropdownItem>
                  <DropdownItem onClick={onClickLogOut}>
                    ログアウト
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )
          }
        </Nav>
      </Navbar>
    </header>
  );
}
